import { CenterGroup } from '../../../lib/types/models/center-group/center-group'
import { AssignEnrollmentsToCenterGroupInput } from '../../../lib/types/models/center-group/center-group-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function assignEnrollmentsToCenterGroup(
  input: AssignEnrollmentsToCenterGroupInput & { centerId: number; groupId: number }
) {
  const { centerId, groupId, ...rest } = input
  return restApiClient
    .url(
      constructApiUrl(API.centers.assignEnrollmentsToCenterGroup.url, { id: centerId, groupId })
    )
    .post<CenterGroup, AssignEnrollmentsToCenterGroupInput>(rest)
}
